import React from "react";
import { BidderTendersQuotesTab } from "../tabs/BidderTendersQuotesTab";

interface RfxBidderTendersQuotesPageProps {
	companyId?: string;
	path?: string;
	tab?: string;
}

/**
 * Bidder Tenders & Quotes route mount.
 *
 * `tab` is now a REAL routed segment, matching the sibling Approvals/Panel
 * mounts: the bidder list moved onto the shared `RfxListPage`, whose active tab
 * is derived from the route and never from local state, so back/forward and
 * deep links work. It was previously accepted and ignored.
 */
export const RfxBidderTendersQuotesPage = ({
	companyId,
	tab,
}: RfxBidderTendersQuotesPageProps) => (
	<BidderTendersQuotesTab companyId={companyId} tab={tab} />
);
